import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { CommercialRefrigerationComponent } from './pages/commercial-refrigeration/commercial-refrigeration.component';
import { ContactComponent } from './pages/contact/contact.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { IceMachinesComponent } from './pages/ice-machines/ice-machines.component';
import { SoftServeMachinesComponent } from './pages/soft-serve-machines/soft-serve-machines.component';

const routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'commercial-refrigeration', component: CommercialRefrigerationComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'customers', component: CustomersComponent },
  { path: 'ice-machines', component: IceMachinesComponent },
  { path: 'soft-serve-machines', component: SoftServeMachinesComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts